__turbopack_context__.v({
  "panel": "SimulatorHubTabPanel-module__TkCqVa__panel",
  "tabs": "SimulatorHubTabPanel-module__TkCqVa__tabs",
});
